import { getMonthlyPrice } from "../../utils";
import { TrackingOptionSwitch } from "../../services/tracking";
import { getOptions } from "@api/utils";
export var SERVICE_TYPE_PROMO_BUBBLE = "promoBubble";
export var SERVICE_TYPE_DEVICE_FLAG = "deviceFlag";
export var SERVICE_TYPE_TARIFF_FLAG = "tariffFlag";
export var SERVICE_TYPE_DATA_VOLUME_BENEFIT = "dataVolumeBenefit";
export var SERVICE_TYPE_DEVICE_INSURANCE = "deviceInsurance";
var Offer = /*@__PURE__*/ (function () {
    function Offer(data) {
        this.usedPass = null;
        this.onChangeListeners = [];
        this.trackingDelay = new Date().getTime() + 3500;
        if (data) {
            if (data.id) {
                this.id = data.id;
            }
            if (data.offerId) {
                this.offerId = data.offerId;
            }
            if (data.sourceId) {
                this.sourceId = data.sourceId;
            }
            if (data.sourceLabel) {
                this.sourceLabel = data.sourceLabel;
            }
        }
        this.components = [];
        this.contextAttributes = [];
        this.mandatoryServices = [];
        this.optionalServices = [];
        this.usedOptions = [];
        this.removedOptions = [];
        this.insuranceOption = [];
    }
    Offer.prototype.getBasketId = function () {
        var id = this.offerId;
        if (this.usedOptions.length > 0) {
            var usableOptionIds = [];
            for (var _i = 0, _a = this.usedOptions; _i < _a.length; _i++) {
                var option = _a[_i];
                usableOptionIds.push(option.id);
            }
            id += "+" + usableOptionIds.sort().join("+");
        }
        else {
            id = this.offerId;
        }
        return id;
    };
    Offer.prototype.loadJSON = function (json) {
        this.id = json.id;
        this.offerId = json.id;
        this.sourceId = json.sourceId;
        this.sourceLabel = json.sourceLabel;
        this.components = json.components;
        this.contextAttributes = json.contextAttributes;
        this.mandatoryServices = json.mandatoryServices;
        this.optionalServices = json.optionalServices;
        this.usedOptions = json.usedOptions;
        this.removedOptions = json.removedOptions ? json.removedOptions : [];
        this.insuranceOption = json.insuranceOption ? json.insuranceOption : [];
    };
    Offer.prototype.toJSON = function () {
        return {
            id: this.id,
            offerId: this.offerId,
            sourceId: this.sourceId,
            sourceLabel: this.sourceLabel,
            components: this.components,
            contextAttributes: this.contextAttributes,
            mandatoryServices: this.mandatoryServices,
            optionalServices: this.optionalServices,
            usedOptions: this.usedOptions,
            removedOptions: this.removedOptions,
            insuranceOption: this.insuranceOption,
        };
    };
    Offer.prototype.getOfferId = function () {
        return this.offerId;
    };
    Offer.prototype.addComponent = function (component) {
        this.components.push(component);
    };
    Offer.prototype.addContextAttribute = function (contextAttribute) {
        this.contextAttributes.push(contextAttribute);
    };
    Offer.prototype.addMandatoryService = function (mandatoryService) {
        this.mandatoryServices.push(mandatoryService);
    };
    Offer.prototype.addOptionalService = function (optionalService) {
        this.optionalServices.push(optionalService);
    };
    Offer.prototype.hasDoubleDealOffer = function () {
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.description) {
                        if (serviceItem.description.additional) {
                            if (serviceItem.description.additional.type ===
                                "doubleDealPromo") {
                                return true;
                            }
                        }
                    }
                }
            }
        }
        return false;
    };
    Offer.prototype.isDiscounted = function () {
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.prices) {
                        for (var _d = 0, _e = serviceItem.prices; _d < _e.length; _d++) {
                            var price = _e[_d];
                            if ((price.value < 0 &&
                                price.recurrenceUnit === "month") ||
                                price.recurrenceUnit === "onetimeBenefit") {
                                return true;
                            }
                        }
                    }
                }
            }
        }
        return false;
    };
    Offer.prototype.isEqualOffer = function (offer) {
        var isEqual = true;
        if (offer.id == this.id &&
            offer.usedOptions.length == this.usedOptions.length &&
            offer.insuranceOption.length == this.insuranceOption.length) {
            var usedOptions = offer.usedOptions;
            var insuranceOptions = offer.insuranceOption;
            var usedInsuranceOptionIds = this.insuranceOption.map(function (opt) { return opt.id; });
            for (var _i = 0, usedOptions_1 = usedOptions; _i < usedOptions_1.length; _i++) {
                var opt = usedOptions_1[_i];
                if (!this.usesOption(opt)) {
                    isEqual = false;
                }
            }
            for (var _a = 0, insuranceOptions_1 = insuranceOptions; _a < insuranceOptions_1.length; _a++) {
                var opt = insuranceOptions_1[_a];
                if (!(usedInsuranceOptionIds.indexOf(opt.id) > -1)) {
                    isEqual = false;
                }
            }
            return isEqual;
        }
        return false;
    };
    Offer.prototype.getMonthlyMandatoryOptionsSum = function () {
        var optionsSum = 0;
        if (this.mandatoryServices) {
            for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
                var service = _a[_i];
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var optionItem = _c[_b];
                    if (optionItem.prices) {
                        if (optionItem.prices.length > 0) {
                            for (var _d = 0, _e = optionItem.prices; _d < _e.length; _d++) {
                                var price = _e[_d];
                                if (price.value > 0 &&
                                    price.recurrenceUnit === "month") {
                                    optionsSum += price.value;
                                }
                            }
                        }
                    }
                }
            }
        }
        return parseFloat(optionsSum.toFixed(2));
    };
    Offer.prototype.getMonthlyMandatoryOptionsSumAfterFirstYear = function () {
        var optionsSum = 0;
        if (this.mandatoryServices) {
            for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
                var service = _a[_i];
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var optionItem = _c[_b];
                    if (optionItem.prices) {
                        if (optionItem.prices.length > 0) {
                            for (var _d = 0, _e = optionItem.prices; _d < _e.length; _d++) {
                                var price = _e[_d];
                                var additionalType = null;
                                if (optionItem.description.additional) {
                                    additionalType =
                                        optionItem.description.additional.type;
                                }
                                if (price.value > 0 &&
                                    price.recurrenceUnit === "month" &&
                                    additionalType !== "promoDiscount") {
                                    optionsSum += price.value;
                                }
                            }
                        }
                    }
                }
            }
        }
        return parseFloat(optionsSum.toFixed(2));
    };
    Offer.prototype.getActivationFee = function () {
        var optionsSum = 0;
        if (this.mandatoryServices) {
            for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
                var service = _a[_i];
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var optionItem = _c[_b];
                    if (optionItem.prices) {
                        if (optionItem.prices.length > 0) {
                            for (var _d = 0, _e = optionItem.prices; _d < _e.length; _d++) {
                                var price = _e[_d];
                                var additionalType = null;
                                if (optionItem.description.additional) {
                                    additionalType =
                                        optionItem.description.additional.type;
                                }
                                if (price.value > 0 &&
                                    price.recurrenceUnit === "onetime" &&
                                    additionalType === "activationFee") {
                                    optionsSum += price.value;
                                }
                            }
                        }
                    }
                }
            }
        }
        return parseFloat(optionsSum.toFixed(2));
    };
    Offer.prototype.getMonthlyMandatoryOptionsSumAfterNMonths = function (months) {
        var optionsSum = 0;
        if (this.mandatoryServices) {
            for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
                var service = _a[_i];
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var optionItem = _c[_b];
                    if (optionItem.prices) {
                        if (optionItem.prices.length > 0) {
                            for (var _d = 0, _e = optionItem.prices; _d < _e.length; _d++) {
                                var price = _e[_d];
                                var additionalType = null;
                                if (optionItem.description.additional) {
                                    additionalType =
                                        optionItem.description.additional.type;
                                }
                                if (price.value > 0 &&
                                    price.recurrenceUnit === "month" &&
                                    price.recurrenceEnd > months &&
                                    additionalType !== "promoDiscount") {
                                    optionsSum += price.value;
                                }
                            }
                        }
                    }
                }
            }
        }
        return parseFloat(optionsSum.toFixed(2));
    };
    Offer.prototype.getMonthlyOptionsSum = function () {
        var optionsSum = 0;
        for (var _i = 0, _a = this.usedOptions; _i < _a.length; _i++) {
            var option = _a[_i];
            if ("undefined" === typeof option.price) {
                option.price = option.prices[0];
            }
            if (SERVICE_TYPE_DEVICE_INSURANCE ===
                option.description.additional.type) {
                continue;
            }
            if (option.price.value > 0 &&
                option.price.recurrenceUnit === "month") {
                optionsSum += option.price.value;
            }
        }
        return parseFloat(optionsSum.toFixed(2));
    };
    Offer.prototype.getMonthlyOptionsSumAfterFirstYear = function () {
        var optionsSum = 0;
        for (var _i = 0, _a = this.usedOptions; _i < _a.length; _i++) {
            var option = _a[_i];
            var additionalType = null;
            if (option.description.additional) {
                additionalType = option.description.additional.type;
            }
            if (option.price.value > 0 &&
                option.price.recurrenceUnit === "month" &&
                additionalType !== "promoDiscount" &&
                additionalType !== SERVICE_TYPE_DEVICE_INSURANCE) {
                optionsSum += option.price.value;
            }
        }
        return parseFloat(optionsSum.toFixed(2));
    };
    Offer.prototype.getMonthlyOptionsSumAfterNMonths = function (months) {
        var optionsSum = 0;
        for (var _i = 0, _a = this.usedOptions; _i < _a.length; _i++) {
            var option = _a[_i];
            var additionalType = null;
            if (option.description.additional) {
                additionalType = option.description.additional.type;
            }
            if (option.price &&
                option.price.value > 0 &&
                option.price.recurrenceUnit === "month" &&
                option.price.recurrenceEnd > months &&
                additionalType !== "promoDiscount" &&
                additionalType !== "deviceInsurance") {
                optionsSum += option.price.value;
            }
        }
        return parseFloat(optionsSum.toFixed(2));
    };
    Offer.prototype.getMonthlyDiscountSum = function () {
        var discountSum = 0;
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.prices) {
                        for (var _d = 0, _e = serviceItem.prices; _d < _e.length; _d++) {
                            var price = _e[_d];
                            if (price.value < 0 &&
                                price.recurrenceUnit === "month" &&
                                price.type === "fixed") {
                                discountSum += price.value;
                            }
                        }
                    }
                }
            }
        }
        return parseFloat(discountSum.toFixed(2));
    };
    Offer.prototype.getMonthlyDiscounts = function () {
        var discounts = [];
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.prices) {
                        for (var _d = 0, _e = serviceItem.prices; _d < _e.length; _d++) {
                            var price = _e[_d];
                            if (price.value < 0 &&
                                price.recurrenceUnit === "month" &&
                                price.type === "fixed") {
                                discounts.push({
                                    value: price.value,
                                    duration: price.recurrenceEnd -
                                        price.recurrenceStart +
                                        1,
                                });
                            }
                        }
                    }
                }
            }
        }
        return discounts;
    };
    Offer.prototype.getMonthlyServicesByType = function (type) {
        var services = [];
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.description.additional.type === type) {
                        for (var _d = 0, _e = serviceItem.prices; _d < _e.length; _d++) {
                            var price = _e[_d];
                            services.push({
                                label: serviceItem.description.label,
                                value: price.value,
                                duration: price.recurrenceEnd -
                                    price.recurrenceStart +
                                    1,
                            });
                        }
                    }
                }
            }
        }
        return services;
    };
    Offer.prototype.getMonthlyDiscountPercentageSum = function () {
        var discountPercentageSum = 0;
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.prices) {
                        for (var _d = 0, _e = serviceItem.prices; _d < _e.length; _d++) {
                            var price = _e[_d];
                            if (price.value < 0 &&
                                price.recurrenceUnit === "month" &&
                                price.type === "percentage") {
                                discountPercentageSum += Math.abs(price.value);
                            }
                        }
                    }
                }
            }
        }
        return parseFloat(discountPercentageSum.toFixed(2));
    };
    Offer.prototype.getMonthlyDiscountPercentages = function () {
        var discountPercentages = [];
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.prices) {
                        for (var _d = 0, _e = serviceItem.prices; _d < _e.length; _d++) {
                            var price = _e[_d];
                            if (price.value < 0 &&
                                price.recurrenceUnit === "month" &&
                                price.type === "percentage") {
                                discountPercentages.push({
                                    value: Math.abs(price.value),
                                    duration: price.recurrenceEnd -
                                        price.recurrenceStart +
                                        1,
                                });
                            }
                        }
                    }
                }
            }
        }
        return discountPercentages;
    };
    Offer.prototype.getMonthlyDiscountPercentageSumAfterFirstYear = function () {
        var discountPercentageSum = 0;
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.prices) {
                        for (var _d = 0, _e = serviceItem.prices; _d < _e.length; _d++) {
                            var price = _e[_d];
                            if (price.value < 0 &&
                                price.recurrenceUnit === "month" &&
                                price.type === "percentage" &&
                                serviceItem.description.additional.type !==
                                    "promoDiscount") {
                                discountPercentageSum += Math.abs(price.value);
                            }
                        }
                    }
                }
            }
        }
        return parseFloat(discountPercentageSum.toFixed(2));
    };
    Offer.prototype.getMonthlyDiscountPercentageSumAfterNMonths = function (n) {
        var discountPercentageSum = 0;
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.prices) {
                        for (var _d = 0, _e = serviceItem.prices; _d < _e.length; _d++) {
                            var price = _e[_d];
                            if (price.value < 0 &&
                                price.recurrenceUnit === "month" &&
                                price.recurrenceEnd > n &&
                                price.type === "percentage" &&
                                serviceItem.description.additional.type !==
                                    "promoDiscount") {
                                discountPercentageSum += Math.abs(price.value);
                            }
                        }
                    }
                }
            }
        }
        return parseFloat(discountPercentageSum.toFixed(2));
    };
    Offer.prototype.getMonthlyDiscountSumAfterFirstYear = function () {
        var discountSum = 0;
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.prices) {
                        for (var _d = 0, _e = serviceItem.prices; _d < _e.length; _d++) {
                            var price = _e[_d];
                            var additionalType = null;
                            if (serviceItem.description.additional) {
                                additionalType =
                                    serviceItem.description.additional.type;
                            }
                            if (price.value < 0 &&
                                price.recurrenceUnit === "month" &&
                                additionalType !== "promoDiscount" &&
                                price.type === "fixed") {
                                discountSum += price.value;
                            }
                        }
                    }
                }
            }
        }
        return parseFloat(discountSum.toFixed(2));
    };
    Offer.prototype.getMonthlyDiscountSumAfterNMonths = function (n) {
        var discountSum = 0;
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.prices) {
                        for (var _d = 0, _e = serviceItem.prices; _d < _e.length; _d++) {
                            var price = _e[_d];
                            var additionalType = null;
                            if (serviceItem.description.additional) {
                                additionalType =
                                    serviceItem.description.additional.type;
                            }
                            if (price.value < 0 &&
                                price.recurrenceUnit === "month" &&
                                price.recurrenceEnd > n &&
                                //&& additionalType !== 'promoDiscount'
                                price.type === "fixed") {
                                discountSum += price.value;
                            }
                        }
                    }
                }
            }
        }
        for (var _f = 0, _g = this.optionalServices; _f < _g.length; _f++) {
            var service = _g[_f];
            if (service.items) {
                for (var _h = 0, _j = service.items; _h < _j.length; _h++) {
                    var serviceItem = _j[_h];
                    if (serviceItem.prices) {
                        for (var _k = 0, _l = serviceItem.prices; _k < _l.length; _k++) {
                            var price = _l[_k];
                            var additionalType = null;
                            if (serviceItem.description.additional) {
                                additionalType =
                                    serviceItem.description.additional.type;
                            }
                            if (price.value < 0 &&
                                price.recurrenceUnit === "month" &&
                                price.recurrenceEnd > n &&
                                additionalType === "voucherBenefit" &&
                                price.type === "fixed") {
                                discountSum += price.value;
                            }
                        }
                    }
                }
            }
        }
        return parseFloat(discountSum.toFixed(2));
    };
    Offer.prototype.getMonthlyOfferPrice = function () {
        var offerPrice = 0;
        for (var _i = 0, _a = this.components; _i < _a.length; _i++) {
            var component = _a[_i];
            if (component.prices) {
                for (var _b = 0, _c = component.prices; _b < _c.length; _b++) {
                    var price = _c[_b];
                    if (price.value > 0 && price.recurrenceUnit === "month") {
                        offerPrice += price.value;
                    }
                }
            }
        }
        return parseFloat(offerPrice.toFixed(2));
    };
    Offer.prototype.getOnetimeOfferPrice = function () {
        var offerPrice = 0;
        for (var _i = 0, _a = this.components; _i < _a.length; _i++) {
            var component = _a[_i];
            if (component.prices) {
                for (var _b = 0, _c = component.prices; _b < _c.length; _b++) {
                    var price = _c[_b];
                    if (price.value > 0 && price.recurrenceUnit === "onetime") {
                        offerPrice += price.value;
                    }
                }
            }
        }
        return parseFloat(offerPrice.toFixed(2));
    };
    Offer.prototype.getMonthlyPrice = function () {
        var offerPrice = this.getMonthlyOfferPrice() + this.getMonthlyMandatoryOptionsSum();
        if (this.isDiscounted()) {
            var discountSum = this.getMonthlyDiscountSum();
            var discountPercentageSum = this.getMonthlyDiscountPercentageSum();
            offerPrice =
                discountSum +
                    offerPrice -
                    offerPrice * (discountPercentageSum / 100);
        }
        if (this.getVoucherBenefits()) {
            var voucherDiscountSum = this.getMonthlyVoucherBenfitSum();
            offerPrice = voucherDiscountSum + offerPrice;
        }
        if (this.hasUsedOptions()) {
            var optionsSum = this.getMonthlyOptionsSum();
            offerPrice = optionsSum + offerPrice;
        }
        return parseFloat(offerPrice.toFixed(2));
    };
    Offer.prototype.getTotalMonthlyDiscountSum = function () {
        var offerPrice = this.getMonthlyOfferPrice() + this.getMonthlyMandatoryOptionsSum();
        var discountSum = 0;
        if (this.isDiscounted()) {
            discountSum = this.getMonthlyDiscountSum();
            var discountPercentageSum = this.getMonthlyDiscountPercentageSum();
            discountSum += offerPrice * (discountPercentageSum / 100);
            discountSum += discountSum;
        }
        return discountSum;
    };
    Offer.prototype.getOnetimePrice = function () {
        var offerPrice = this.getOnetimeOfferPrice();
        return parseFloat(offerPrice.toFixed(2));
    };
    Offer.prototype.getMonthlyPriceAfterFirstYear = function () {
        var offerPrice = this.getMonthlyOfferPrice() +
            this.getMonthlyMandatoryOptionsSumAfterFirstYear();
        if (this.isDiscounted()) {
            var discountSum = this.getMonthlyDiscountSumAfterFirstYear();
            var discountPercentageSum = this.getMonthlyDiscountPercentageSumAfterFirstYear();
            offerPrice =
                discountSum +
                    offerPrice -
                    offerPrice * (discountPercentageSum / 100);
        }
        if (this.usedOptions.length > 0) {
            var optionsSum = this.getMonthlyOptionsSumAfterFirstYear();
            offerPrice = optionsSum + offerPrice;
        }
        return parseFloat(offerPrice.toFixed(2));
    };
    Offer.prototype.getMonthlyPriceAfterNMonths = function (n) {
        if (this.getMinimumTerm() < 2) {
            return this.getMonthlyPrice();
        }
        var offerPrice = this.getMonthlyOfferPrice() +
            this.getMonthlyMandatoryOptionsSumAfterNMonths(n);
        if (this.isDiscounted()) {
            var discountSum = this.getMonthlyDiscountSumAfterNMonths(n);
            var discountPercentageSum = this.getMonthlyDiscountPercentageSumAfterNMonths(n);
            offerPrice =
                discountSum +
                    offerPrice -
                    offerPrice * (discountPercentageSum / 100);
        }
        if (this.usedOptions.length > 0) {
            var optionsSum = this.getMonthlyOptionsSumAfterNMonths(n);
            offerPrice = optionsSum + offerPrice;
        }
        return parseFloat(offerPrice.toFixed(2));
    };
    Offer.prototype.getDiscounts = function () {
        var result = [];
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.prices) {
                        var match = false;
                        for (var _d = 0, _e = serviceItem.prices; _d < _e.length; _d++) {
                            var price = _e[_d];
                            if (price.value < 0) {
                                match = true;
                            }
                        }
                        if (match) {
                            result.push(serviceItem);
                        }
                    }
                }
            }
        }
        return result;
    };
    Offer.prototype.getStaticServices = function () {
        var result = [];
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.description.additional) {
                        if (serviceItem.description.additional.type) {
                            continue;
                        }
                    }
                    if (!serviceItem.prices) {
                        result.push(serviceItem);
                    }
                    else {
                        if (serviceItem.prices.length === 0) {
                            result.push(serviceItem);
                        }
                    }
                }
            }
        }
        return result;
    };
    Offer.prototype.getServicesByType = function (type) {
        var result = [];
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.description.additional) {
                        if (serviceItem.description.additional.type === type) {
                            result.push(serviceItem);
                        }
                    }
                }
            }
        }
        return result;
    };
    Offer.prototype.getOptionalServiceByType = function (type) {
        var result = [];
        for (var _i = 0, _a = this.optionalServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.description.additional) {
                        if (serviceItem.description.additional.type === type) {
                            result.push(serviceItem);
                        }
                    }
                }
            }
        }
        return result;
    };
    Offer.prototype.getOptionalServiceByID = function (id) {
        var result = [];
        for (var _i = 0, _a = this.optionalServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.description.id) {
                        if (serviceItem.description.id === id) {
                            var offerUsableOption = (serviceItem);
                            result.push(offerUsableOption);
                        }
                    }
                }
            }
        }
        return result.length > 0 ? result[0] : null;
    };
    Offer.prototype.getBackendIdsBySystem = function (system) {
        var result = [];
        for (var _i = 0, _a = this.mandatoryServices; _i < _a.length; _i++) {
            var service = _a[_i];
            if (service.items) {
                for (var _b = 0, _c = service.items; _b < _c.length; _b++) {
                    var serviceItem = _c[_b];
                    if (serviceItem.description.backendId) {
                        if (serviceItem.description.backendId) {
                            for (var _d = 0, _e = serviceItem.description
                                .backendId; _d < _e.length; _d++) {
                                var backendId = _e[_d];
                                if (backendId.system === system) {
                                    result.push(backendId);
                                }
                            }
                        }
                    }
                }
            }
        }
        return result;
    };
    Offer.prototype.setUsedOptions = function (usedOptions) {
        var _this = this;
        this.usedOptions = usedOptions;
        this.usedPass = null;
        usedOptions.forEach(function (opt) {
            if (SERVICE_TYPE_DEVICE_INSURANCE ===
                opt.description.additional.type) {
                _this.insuranceOption.push(opt);
            }
            if (_this.isPassWithIdAvailable(opt.id)) {
                if (_this.usedPass) {
                    _this.cancelOption(_this.usedPass);
                }
                _this.usedPass = opt;
            }
        });
        return this;
    };
    Offer.prototype.getUsedOptions = function () {
        return this.usedOptions;
    };
    Offer.prototype.getInsuranceOption = function () {
        return this.insuranceOption;
    };
    Offer.prototype.getInsurancePrice = function () {
        return this.insuranceOption[0].prices[0].value;
    };
    Offer.prototype.hasUsedOptions = function () {
        return this.usedOptions.length > 0;
    };
    Offer.prototype.usesOption = function (option) {
        var options = this.usedOptions;
        for (var _i = 0, options_1 = options; _i < options_1.length; _i++) {
            var usedOption = options_1[_i];
            if (option && usedOption.id === option.id) {
                return true;
            }
        }
        return false;
    };
    Offer.prototype.entityDecode = function (option) {
        return option.replace(/&#(\d+);/g, function (match, dec) {
            return String.fromCharCode(dec);
        });
    };
    Offer.prototype.usePass = function (passId) {
        var passes = this.getAvailablePasses();
        var index = passes.map(function (pass) { return pass.id; }).indexOf(passId);
        if (index > -1) {
            if (this.usedPass != null) {
                this.cancelPass(true);
            }
            this.usedPass = passes[index];
            var usableOption = JSON.parse(JSON.stringify(this.usedPass));
            usableOption.description.additional.type = "bundleOption";
            this.useOption(usableOption);
        }
    };
    Offer.prototype.cancelPass = function (doNotTrack) {
        if (doNotTrack === void 0) {
            doNotTrack = false;
        }
        this.cancelOption(this.usedPass, doNotTrack);
        this.usedPass = null;
    };
    Offer.prototype.useOption = function (option) {
        this.removedOptions = [];
        var options = this.usedOptions;
        var old = this.clone(this);
        for (var _i = 0, options_2 = options; _i < options_2.length; _i++) {
            var usedOption = options_2[_i];
            if (usedOption.id === option.id) {
                return true;
            }
        }
        var availableOptions = getOptions(this);
        for (var _a = 0, availableOptions_1 = availableOptions; _a < availableOptions_1.length; _a++) {
            var availableOption = availableOptions_1[_a];
            if (availableOption.id === option.id) {
                this.usedOptions.push(option);
                if (SERVICE_TYPE_DEVICE_INSURANCE ===
                    option.description.additional.type) {
                    this.insuranceOption.push(option);
                }
                var removedOptions = this.removedOptions;
                var match = -1;
                for (var i = 0; i < removedOptions.length; i++) {
                    if (removedOptions[i].id === option.id) {
                        match = i;
                        break;
                    }
                }
                if (match > -1) {
                    this.removedOptions.splice(match, 1);
                }
                this.id = this.getBasketId();
                this.onChange(old, this);
                this.trackingSelectedOption = option;
                this.executeOptionTrackingEvent();
                return true;
            }
        }
        // throw new Error('Cannot add option because it is not included in the offer.');
    };
    Offer.prototype.executeOptionTrackingEvent = function () {
        if (this.trackingDelay < new Date().getTime()) {
            var optionSwitchTracking = new TrackingOptionSwitch();
            if (this.trackingSelectedOption) {
                optionSwitchTracking.addSelectedOption(this.entityDecode(this.trackingSelectedOption.description.label), "option", this.getTrackingOptionId(this.trackingSelectedOption) + "", getMonthlyPrice(this.trackingSelectedOption.prices), 1);
            }
            if (this.trackingRemovedOption) {
                optionSwitchTracking.addRemovedOption(this.entityDecode(this.trackingRemovedOption.description.label), "option", this.getTrackingOptionId(this.trackingRemovedOption) + "", getMonthlyPrice(this.trackingRemovedOption.prices), 1);
            }
            optionSwitchTracking.track();
            this.trackingSelectedOption = null;
            this.trackingRemovedOption = null;
        }
    };
    Offer.prototype.getTrackingOptionId = function (option) {
        var trackingOptionId = option.id;
        if (option.description) {
            if (option.description.backendId) {
                if (option.description.backendId[0].system === "VLUX") {
                    trackingOptionId = option.description.backendId[0].value;
                }
            }
        }
        return trackingOptionId;
    };
    Offer.prototype.clone = function (offer) {
        return JSON.parse(JSON.stringify(offer));
    };
    Offer.prototype.cancelOption = function (option, doNotTrack) {
        if (doNotTrack === void 0) {
            doNotTrack = false;
        }
        this.removedOptions = [];
        var options = this.usedOptions;
        var match = -1;
        var old = this.clone(this);
        this.removedOptions.push(option);
        if (SERVICE_TYPE_DEVICE_INSURANCE === option.description.additional.type) {
            this.insuranceOption = [];
        }
        for (var i = 0; i < options.length; i++) {
            if (options[i].id === option.id) {
                match = i;
                break;
            }
        }
        if (match > -1) {
            this.usedOptions.splice(match, 1);
            this.id = this.getBasketId();
            this.onChange(old, this);
            this.trackingRemovedOption = option;
            if (!doNotTrack)
                this.executeOptionTrackingEvent();
        }
        return true;
    };
    Offer.prototype.onChange = function (old, current) {
        for (var _i = 0, _a = this.onChangeListeners; _i < _a.length; _i++) {
            var onChangeListener = _a[_i];
            onChangeListener(old, current);
        }
    };
    Offer.prototype.subscribe = function (event, listener) {
        if (event === "change") {
            this.onChangeListeners.push(listener);
        }
    };
    Offer.prototype.getDeviceMonthlyPrice = function () {
        var monthlyPrice = this.getMonthlyPrice();
        var mandatorySum = this.getMonthlyDiscountSum();
        var usedOptionsSum = this.getMonthlyOptionsSum();
        var tariffPrice;
        for (var _i = 0, _a = this.components; _i < _a.length; _i++) {
            var component = _a[_i];
            if (component.type === "tariffMobile") {
                tariffPrice = getMonthlyPrice(component.prices);
            }
        }
        var price = monthlyPrice - mandatorySum - usedOptionsSum - tariffPrice;
        if (price < 0) {
            price = 0;
        }
        return parseFloat(price.toFixed(2));
    };
    Offer.prototype.getTariffBasePrice = function () {
        var tariffPrice;
        for (var _i = 0, _a = this.components; _i < _a.length; _i++) {
            var component = _a[_i];
            if (component.type === "tariffMobile") {
                tariffPrice = getMonthlyPrice(component.prices);
            }
        }
        return parseFloat(tariffPrice.toFixed(2));
    };
    Offer.prototype.getTariffId = function () {
        for (var _i = 0, _a = this.components; _i < _a.length; _i++) {
            var component = _a[_i];
            if (component.type === "tariffMobile") {
                return component.refId.toString();
            }
        }
        return "";
    };
    Offer.prototype.getLabel = function () {
        var labels = [];
        for (var _i = 0, _a = this.components; _i < _a.length; _i++) {
            var component = _a[_i];
            if (component.internalLabel) {
                labels.push(component.internalLabel);
            }
        }
        return labels.join(" mit ");
    };
    Offer.prototype.getUsedPass = function () {
        return this.usedPass;
    };
    Offer.prototype.isPassWithIdAvailable = function (id) {
        var availablePasses = this.getAvailablePasses();
        return availablePasses.map(function (pass) { return pass.id; }).indexOf(id) > -1;
    };
    Offer.prototype.getAvailablePasses = function () {
        var availableOptions = getOptions(this);
        var availablePasses = availableOptions.filter(function (option) { return option.description.additional.type == "gigaPass"; });
        return availablePasses;
    };
    Offer.prototype.hasAnyPasses = function () {
        return this.getAvailablePasses().length > 0;
    };
    Offer.prototype.getMinimumTerm = function () {
        var mandatoryServices = this.mandatoryServices.reduce(function (acc, current) { return acc.concat(current.items); }, []);
        var index = mandatoryServices.findIndex(function (item) { return item.description.additional.type == "minimumTerm"; });
        if (index > -1) {
            return mandatoryServices[index].prices[0].recurrenceEnd;
        }
        else
            return 0;
    };
    // VOUCHERS
    Offer.prototype.getVoucherBenefits = function () {
        var voucherBenefits = [];
        this.usedOptions.forEach(function (option) {
            if (option.description.additional.type === "voucherBenefit") {
                voucherBenefits.push(option);
            }
        });
        return voucherBenefits;
    };
    Offer.prototype.getMonthlyVoucherBenfitSum = function () {
        var discountSum = 0;
        var voucherBenefits = this.getVoucherBenefits();
        for (var _i = 0, voucherBenefits_1 = voucherBenefits; _i < voucherBenefits_1.length; _i++) {
            var benefit = voucherBenefits_1[_i];
            if (benefit.prices) {
                for (var _a = 0, _b = benefit.prices; _a < _b.length; _a++) {
                    var price = _b[_a];
                    if (price.value < 0 &&
                        price.recurrenceUnit === "month" &&
                        price.type === "fixed") {
                        discountSum += price.value;
                    }
                }
            }
        }
        return parseFloat(discountSum.toFixed(2));
    };
    Offer.prototype.getOnetimeVoucherBenefits = function () {
        var onetimeVoucherBenefits = [];
        this.usedOptions.forEach(function (option) {
            if (option.description.additional.type === "onetimeVoucherBenefit") {
                onetimeVoucherBenefits.push(option);
            }
        });
        return onetimeVoucherBenefits;
    };
    return Offer;
}());
export { Offer };



//////////////////
// WEBPACK FOOTER
// ./app/bundles/enterprise-shop/src/api/schema/offer/offer.ts
// module id = null
// module chunks = 